import { BrowserModule } from '@angular/platform-browser'
import { NgModule, ErrorHandler, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
//import {TransferHttpCacheModule} from '@angular/ssr'
import { LayoutModule } from '@angular/cdk/layout'
import { AppRoutingModule } from './app-routing.module'

import { GlobalErrorHandler } from './GlobalErrorHandler'
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger'
import { environment } from '../environments/environment'

import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ApiInterceptor } from './core/services/auth.interceptor'
import { LoginAuthInterceptorExtension } from './core/services/login-auth.interceptor.extension'
import { NinthWaveAuthInterceptorExtension } from './core/services/ninthwave-auth.interceptor.extension'

import { AppComponent } from './app.component'
import { HomeComponent } from './shared/components/home/home.component'
import { FaqComponent } from './modules/faq/faq.component'
import { ArticleComponent } from './shared/components/article/article.component'
import { DatePipe } from '@angular/common';
import { LeaveSiteComponent } from './shared/components/leave-site/leave-site.component'

import { SharedModule } from './shared.module'
import { CreditToolsModule } from './modules/credit-tools/credit-tools.module';
import { ActivationComponent } from './shared/components/activation/activation.component'
import { AuthLocalDevInterceptor } from '../app/core/services/auth-local-dev.interceptor';


import {WhyUsModule}  from './modules/why-us/why-us.module';
import { WebAppFooterComponent } from './shared/components/web-prequal-footer/web-prequal-footer.component';
//import { HsfsRoutingModule } from './verticals/hsfs/hsfs-routing.module'

/* import {TranslateHttpLoader} from '@ngx-translate/http-loader'
import { HttpClientModule, HttpClient} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'

export function HttpLoaderFactory(http:HttpClient){
  return new TranslateHttpLoader(http,  `https://assetsuat.icreditworks.com/public/webapp/assets/other/i18n/`, '.json');
}
 */


/* export function MyCustomHttpLoaderFactory(myUserService: MyUserService, httpClient: HttpClient) {
  return new MyCustomHttpLoader(myUserService, httpClient);
}
 */
export function chooseLogLevel(): NgxLoggerLevel {
  const logLevel: string = environment.LOG_LEVEL
  if (!logLevel) {
    return NgxLoggerLevel.INFO
  }
  switch (logLevel) {
    case 'TRACE':
      return NgxLoggerLevel.TRACE
    case 'DEBUG':
      return NgxLoggerLevel.DEBUG
    case 'INFO':
      return NgxLoggerLevel.INFO
    case 'LOG':
      return NgxLoggerLevel.LOG
    case 'WARN':
      return NgxLoggerLevel.WARN
    case 'ERROR':
      return NgxLoggerLevel.ERROR
    case 'FATAL':
      return NgxLoggerLevel.FATAL
    case 'OFF':
      return NgxLoggerLevel.OFF
    default:
      return NgxLoggerLevel.DEBUG
  }

}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ActivationComponent,
    FaqComponent,
    ArticleComponent,
    LeaveSiteComponent,
    WebAppFooterComponent,

  ],

  imports: [
     LoggerModule.forRoot({
      level: chooseLogLevel(),
    }),
    BrowserModule,
  //  BrowserModule.withServerTransition({ appId: 'serverApp' }),
    SharedModule,
   // TransferHttpCacheModule,
    AppRoutingModule,
    // HsfsRoutingModule,
    LayoutModule,
    CreditToolsModule,
    WhyUsModule,
    DatePipe,
      /*     TranslateModule.forRoot({
      loader:{
        provide: TranslateLoader,
        useFactory: MyCustomHttpLoaderFactory,
        deps: [MyUserService,HttpClient],
      },
      defaultLanguage: 'en'
    }) , */
    
    /*    HttpClientModule,
       TranslateModule.forRoot({
        loader:{
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      defaultLanguage: 'en'
    }) , */
  ],
  exports:[
    WebAppFooterComponent
  ],
  providers: [
    LoginAuthInterceptorExtension,
    NinthWaveAuthInterceptorExtension,
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthLocalDevInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    GlobalErrorHandler,
  ],
   schemas:[NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA] ,
  bootstrap: [AppComponent],
})
export class AppModule {}
